import { axios } from '@/lib/axios';

export const getCart = async (id: number) => {
    const { data } = await axios.get(`v1/get-cart/${485}`);
    return data;
};
